<template>
  <v-container
    id="banks"
    fluid
    class="page-container">
    <v-row>
      <v-col>

        <BankList></BankList>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';
  import BankList from '@/components/Banks/BankList';

  export default {
    name: 'Banks',
    extends: DataComponentBase,
    components: {
      BankList,
    },

    data () {
      return {
      }
    },

    computed: {
    },

    methods: {
    },

  };
</script>

